import React from "react";
import { Flag } from "@americanexpress/dls-react";
import PropTypes from "prop-types";
import "../CommonComponent/CommonStyle.css";

const CountryFlag = ({ country, countryCode, transCountry }) => {
    return (
        <div className="flex items-center">
            <Flag
                className="flagWidth"
                alt={country}
                countryCode={country ? countryCode : ''}
                size="md"
            />
            <span className="pad-l-4">
                {transCountry}
            </span>
        </div>
    );
};


CountryFlag.propTypes = {
    country: PropTypes.string.isRequired,
};

export default CountryFlag;
